function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.608 16.3732H1.39158C1.07898 16.3732 0.790122 16.2064 0.633824 15.9357C0.477526 15.665 0.477528 15.3315 0.633829 15.0607L8.74158 1.06073C8.898 0.79045 9.18661 0.624023 9.49889 0.624023C9.81117 0.624023 10.0998 0.79045 10.2562 1.06073L18.364 15.0607C18.5202 15.3313 18.5203 15.6647 18.3642 15.9353C18.2081 16.206 17.9195 16.3729 17.6071 16.3732H17.608ZM8.6252 11.9982V13.7482H9.44158H9.49845H9.55533H10.3735V11.9982H8.6252ZM8.6252 5.87323V10.2482H10.3752V5.87323H8.6252Z",
  fill: "#555555"
});

function SvgWarningIconGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconGrey);
export default __webpack_public_path__ + "static/media/warning-icon-grey.eaa500af.svg";
export { ForwardRef as ReactComponent };